/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal } from '../twd'

export default ({list=[]} = {}) => {

    return <React.Fragment>
    <div className="modal-dialog modal-md">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="bond-detail-underwriter-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h3 className="modal-title text-center vertical-offset-sm">Underwriters</h3>
            <div className="row form-group subhead">
            <div className="col-xs-12 col-md-12">

            <div className="table-responsive">
            <table
                data-name='bond-detail-underwriter-table'
                className="table align-top table-striped">
            <thead>
                <tr>
                <th>Underwriter</th>
                <th>Syndicate</th>
                </tr>
            </thead>
            <tbody>{
                list.map((r,i)=> {
                    return <tr key={i}>
                        <td dangerouslySetInnerHTML={{__html:r.name}}></td>
                        <td>{r.rank}</td>
                    </tr>
                })
            }</tbody>
            </table>
            </div>

            </div>
            </div>
        </div>

    </div>
    </div>
    </React.Fragment>
}


